@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.dashboard.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.dashboard.generated.resources/"

internal val Res.string.dashboard_banner_has_patients: StringResource by lazy {
      StringResource("string:dashboard_banner_has_patients", "dashboard_banner_has_patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 141),
      ))
    }

internal val Res.string.dashboard_banner_no_patients: StringResource by lazy {
      StringResource("string:dashboard_banner_no_patients", "dashboard_banner_no_patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152, 176),
      ))
    }

internal val Res.string.dashboard_collected: StringResource by lazy {
      StringResource("string:dashboard_collected", "dashboard_collected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329, 39),
      ))
    }

internal val Res.string.dashboard_error_load_failed: StringResource by lazy {
      StringResource("string:dashboard_error_load_failed", "dashboard_error_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 369, 71),
      ))
    }

internal val Res.string.dashboard_last_session: StringResource by lazy {
      StringResource("string:dashboard_last_session", "dashboard_last_session", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 441, 58),
      ))
    }

internal val Res.string.dashboard_no_data: StringResource by lazy {
      StringResource("string:dashboard_no_data", "dashboard_no_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 500, 57),
      ))
    }

internal val Res.string.dashboard_outstanding: StringResource by lazy {
      StringResource("string:dashboard_outstanding", "dashboard_outstanding", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 558, 41),
      ))
    }

internal val Res.string.dashboard_overdue: StringResource by lazy {
      StringResource("string:dashboard_overdue", "dashboard_overdue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 600, 37),
      ))
    }

internal val Res.string.dashboard_paid: StringResource by lazy {
      StringResource("string:dashboard_paid", "dashboard_paid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 638, 34),
      ))
    }

internal val Res.string.dashboard_patients: StringResource by lazy {
      StringResource("string:dashboard_patients", "dashboard_patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 673, 38),
      ))
    }

internal val Res.string.dashboard_pending: StringResource by lazy {
      StringResource("string:dashboard_pending", "dashboard_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 951, 41),
      ))
    }

internal val Res.string.dashboard_pending_confirm: StringResource by lazy {
      StringResource("string:dashboard_pending_confirm", "dashboard_pending_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 712, 45),
      ))
    }

internal val Res.string.dashboard_pending_no_ocurrio: StringResource by lazy {
      StringResource("string:dashboard_pending_no_ocurrio", "dashboard_pending_no_ocurrio", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 758, 52),
      ))
    }

internal val Res.string.dashboard_pending_reminders: StringResource by lazy {
      StringResource("string:dashboard_pending_reminders", "dashboard_pending_reminders", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 811, 75),
      ))
    }

internal val Res.string.dashboard_pending_title: StringResource by lazy {
      StringResource("string:dashboard_pending_title", "dashboard_pending_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 887, 63),
      ))
    }

internal val Res.string.dashboard_reminders_count: StringResource by lazy {
      StringResource("string:dashboard_reminders_count", "dashboard_reminders_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 993, 65),
      ))
    }

internal val Res.string.dashboard_reminders_title: StringResource by lazy {
      StringResource("string:dashboard_reminders_title", "dashboard_reminders_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1059, 65),
      ))
    }

internal val Res.string.dashboard_session_item: StringResource by lazy {
      StringResource("string:dashboard_session_item", "dashboard_session_item", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1125, 46),
      ))
    }

internal val Res.string.dashboard_session_status_scheduled: StringResource by lazy {
      StringResource("string:dashboard_session_status_scheduled", "dashboard_session_status_scheduled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1172, 58),
      ))
    }

internal val Res.string.dashboard_session_type_double: StringResource by lazy {
      StringResource("string:dashboard_session_type_double", "dashboard_session_type_double", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1231, 45),
      ))
    }

internal val Res.string.dashboard_session_type_final: StringResource by lazy {
      StringResource("string:dashboard_session_type_final", "dashboard_session_type_final", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1277, 44),
      ))
    }

internal val Res.string.dashboard_session_type_first: StringResource by lazy {
      StringResource("string:dashboard_session_type_first", "dashboard_session_type_first", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1322, 48),
      ))
    }

internal val Res.string.dashboard_session_type_regular: StringResource by lazy {
      StringResource("string:dashboard_session_type_regular", "dashboard_session_type_regular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1371, 50),
      ))
    }

internal val Res.string.dashboard_status_overdue: StringResource by lazy {
      StringResource("string:dashboard_status_overdue", "dashboard_status_overdue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1422, 44),
      ))
    }

internal val Res.string.dashboard_status_pending: StringResource by lazy {
      StringResource("string:dashboard_status_pending", "dashboard_status_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1467, 44),
      ))
    }

internal val Res.string.dashboard_status_up_to_date: StringResource by lazy {
      StringResource("string:dashboard_status_up_to_date", "dashboard_status_up_to_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1512, 43),
      ))
    }

internal val Res.string.dashboard_title: StringResource by lazy {
      StringResource("string:dashboard_title", "dashboard_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1556, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("dashboard_banner_has_patients", Res.string.dashboard_banner_has_patients)
  map.put("dashboard_banner_no_patients", Res.string.dashboard_banner_no_patients)
  map.put("dashboard_collected", Res.string.dashboard_collected)
  map.put("dashboard_error_load_failed", Res.string.dashboard_error_load_failed)
  map.put("dashboard_last_session", Res.string.dashboard_last_session)
  map.put("dashboard_no_data", Res.string.dashboard_no_data)
  map.put("dashboard_outstanding", Res.string.dashboard_outstanding)
  map.put("dashboard_overdue", Res.string.dashboard_overdue)
  map.put("dashboard_paid", Res.string.dashboard_paid)
  map.put("dashboard_patients", Res.string.dashboard_patients)
  map.put("dashboard_pending", Res.string.dashboard_pending)
  map.put("dashboard_pending_confirm", Res.string.dashboard_pending_confirm)
  map.put("dashboard_pending_no_ocurrio", Res.string.dashboard_pending_no_ocurrio)
  map.put("dashboard_pending_reminders", Res.string.dashboard_pending_reminders)
  map.put("dashboard_pending_title", Res.string.dashboard_pending_title)
  map.put("dashboard_reminders_count", Res.string.dashboard_reminders_count)
  map.put("dashboard_reminders_title", Res.string.dashboard_reminders_title)
  map.put("dashboard_session_item", Res.string.dashboard_session_item)
  map.put("dashboard_session_status_scheduled", Res.string.dashboard_session_status_scheduled)
  map.put("dashboard_session_type_double", Res.string.dashboard_session_type_double)
  map.put("dashboard_session_type_final", Res.string.dashboard_session_type_final)
  map.put("dashboard_session_type_first", Res.string.dashboard_session_type_first)
  map.put("dashboard_session_type_regular", Res.string.dashboard_session_type_regular)
  map.put("dashboard_status_overdue", Res.string.dashboard_status_overdue)
  map.put("dashboard_status_pending", Res.string.dashboard_status_pending)
  map.put("dashboard_status_up_to_date", Res.string.dashboard_status_up_to_date)
  map.put("dashboard_title", Res.string.dashboard_title)
}
